import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const CtaBand = ({ heading, copy, note, buttonText = "Enquire About Availability", ctaTo = "/contact", testId = "cta-band" }) => (
  <section className="py-16 sm:py-20" data-testid={testId}>
    <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
      <div className="rounded-[2.5rem] bg-[#3F4A38] text-[#F7F4ED] px-8 py-12 sm:p-16 text-center relative overflow-hidden">
        <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight" data-testid={`${testId}-heading`}>{heading}</h2>
        <p className="mt-5 text-base sm:text-lg text-[#F7F4ED]/75 max-w-xl mx-auto leading-relaxed">{copy}</p>
        <Link
          to={ctaTo}
          data-testid={`${testId}-button`}
          className="mt-8 inline-flex items-center gap-2 rounded-full bg-[#F7F4ED] text-[#292A26] px-7 py-3.5 text-sm font-semibold hover:bg-white transition-colors"
        >
          {buttonText}
          <ArrowRight className="w-4 h-4" />
        </Link>
        {note && <p className="mt-6 text-xs text-[#F7F4ED]/50 max-w-md mx-auto">{note}</p>}
      </div>
    </div>
  </section>
);
